// Band member data
// Information about each band member and their roles

import { BandMember, Band } from '../types';

export const bandMembers: BandMember[] = [
  {
    id: 1,
    name: 'Christian Andersen',
    instruments: ['Guitar', 'Bass', 'Drums', 'Vocals'],
    role: 'Multi-instrumentalist',
    bio: 'Most recently drumming with the band Riptide, Christian has been playing in the local scene since 2010.',
    joinYear: 2024,
    profilePhoto: '/profile_photos/christian.png',
    socialMedia: {
      youtube: 'https://www.youtube.com/@wcchristian',
      instagram: 'https://instagram.com/wcchristian',
      twitch: 'https://twitch.tv/wcchristian',
      twitter: 'https://twitter.com/wcchristian'
    }
  },
  {
    id: 2,
    name: 'Cody Hoenisch',
    instruments: ['Drums', 'Bass', 'Vocals'],
    role: 'Rhythm Section',
    bio: 'With a history of playing shows since 2008, Cody has been in several bands such as Indiscrepancy, Nothing More than a Ghost, and Ex Omen as a songwriter, drummer, and vocalist.',
    joinYear: 2024,
    profilePhoto: '/profile_photos/cody.jpeg',
    socialMedia: {
      youtube: 'https://youtube.com/@CodyDSG',
      twitch: 'https://twitch.tv/CodyDSG',
      instagram: 'https://instagram.com/CodyDSG'
    }
  },
  {
    id: 3,
    name: 'Mike Dyrdal',
    instruments: ['Guitar', 'Bass'],
    role: 'Lead Guitar',
    bio: 'Originally from the band Riptide, Mike has been playing in the local scene since 2010.',
    joinYear: 2024,
    profilePhoto: '/profile_photos/mike.png',
    socialMedia: {
      instagram: 'https://instagram.com/mdyrdal',
    }
  }
];


export const band: Band = {
  name: 'Lost Signal',
  youtube: 'https://youtube.com/@lostsignalmn',
  instagram: 'https://instagram.com/lostsignalmn',
  facebook: 'https://facebook.com/lostsignalmn',
  twitch: 'https://twitch.tv/lostsignalmn',
  members: bandMembers
};
